import { MediaUploadCheck, MediaPlaceholder } from '@wordpress/block-editor';
import { URLInput } from '@wordpress/block-editor';
import { GoVideo } from 'react-icons/go';

const VideoUploader = ({attributes, setAttributes}) => {

    const vayu_blocks_u_tube_video_change = (url) => {
        // Decode the URL to handle encoded characters like &amp;
        const decodedUrl = decodeURIComponent(url);
    
        // Regex for different types of YouTube URLs
        const youtubeRegexShortened = /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([\w-]{11})(?:\?si=[\w-]+)?/;
        const youtubeRegexStandard = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:watch\?v=|embed\/)([\w-]{11})(?:[^\s]*)?(?:&start=(\d+))?/;
        const iframeRegex = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([\w-]{11})\?[^&]*&start=(\d+)/;
        const youtubeRegexShorts = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([\w-]{11})(?:\?si=[\w-]+)?/;
    
        let match, videoId, startTime = null;
    
        // Check for shortened URL (youtu.be)
        match = decodedUrl.match(youtubeRegexShortened);
        if (match) {

            videoId = match[1];

            const startMatch = decodedUrl.match(/t=(\d+)/);
            startTime = startMatch ? startMatch[1] : null; // Extract the start time if present

            if (decodedUrl.match(youtubeRegexShorts)) {
                setAttributes({
                    videowidth: {
                        Desktop: '266px',
                        Tablet: '266px',
                        Mobile: '266px'
                    },
                    videoheight: {
                        Desktop: '473px',
                        Tablet: '473px',
                        Mobile: '473px'
                    },
                    youtubeshorts: true,
                    imageaspectratio:{
                        Desktop: "9/16",
                        Mobile:"9/16",
                        Tablet: "9/16"
                    }
                });
            } else {
                setAttributes({
                    videoheight: {
                        Desktop: '315px',
                        Tablet: '315px',
                        Mobile: '315px'
                    },
                    videowidth: {
                        Desktop: '560px',
                        Tablet: '560px',
                        Mobile: '560px'
                    },
                    youtubeshorts: false,
                    imageaspectratio:{
                        Desktop: "16/9",
                        Mobile:"16/9",
                        Tablet: "16/9"
                    }
                });
            }
            

        } else {
            // Check for standard YouTube URL, iframe URL, or Shorts URL
            match = decodedUrl.match(youtubeRegexStandard) || decodedUrl.match(iframeRegex) || decodedUrl.match(youtubeRegexShorts);
            if (match) {
                videoId = match[1];
                // Extract start time if it's present in the URL
                const startMatch = decodedUrl.match(/start=(\d+)/);
                startTime = startMatch ? startMatch[1] : null; // Extract the start time if present

                if (decodedUrl.match(youtubeRegexShorts)) {
                    setAttributes({
                        videowidth: {
                            Desktop: '266px',
                            Tablet: '266px',
                            Mobile: '266px'
                        },
                        videoheight: {
                            Desktop: '473px',
                            Tablet: '473px',
                            Mobile: '473px'
                        },
                        youtubeshorts: true,
                        imageaspectratio:{
                            Desktop: "9/16",
                            Mobile:"9/16",
                            Tablet: "9/16"
                        }
                    });
                } else {
                    setAttributes({
                        videoheight: {
                            Desktop: '315px',
                            Tablet: '315px',
                            Mobile: '315px'
                        },
                        videowidth: {
                            Desktop: '560px',
                            Tablet: '560px',
                            Mobile: '560px'
                        },
                        youtubeshorts: false,
                        imageaspectratio:{
                            Desktop: "16/9",
                            Mobile:"16/9",
                            Tablet: "16/9"
                        }
                    });
                }
                
            } else {
                // If no valid match is found, clear the video URL and start time
                setAttributes({ youvideoUrl: '', startTime: '',
                    imageaspectratio:{
                        Desktop: "16/9",
                        Mobile:"16/9",
                        Tablet: "16/9"
                    }
                });
            
                return;
            }
        }

        if (startTime !== null) {
            startTime = Number(startTime); // Ensure startTime is a number
        }

        // Save videoId and startTime if valid
        setAttributes({
            youvideoUrl: videoId,
            startTime: startTime
        });
    };
    
    const vayu_blcks_u_tube_url = () => {
        if (attributes.youvideoUrl) {
            const videoId = attributes.youvideoUrl;
            return `https://www.youtube.com/watch?v=${videoId}`; // Regular URL without start time
        }
        return ''; // Return empty if no video URL is available
    };

    const vayu_blocks_vimeo_change = (url) => {
        const decodedUrl = decodeURIComponent(url.trim());
    
        // Match all valid Vimeo formats
        const vimeoRegex = /vimeo\.com\/(?:video\/)?(\d+)/;
    
        const match = decodedUrl.match(vimeoRegex);
    
        if (match && match[1]) {
            const videoId = match[1];
    
            setAttributes({
                vimeourl: videoId,
                imageaspectratio:{
                    Desktop: "16/9",
                    Mobile:"16/9",
                    Tablet: "16/9"
                },
                videoheight: {
                    Desktop: '315px',
                    Tablet: '315px',
                    Mobile: '315px'
                },
                videowidth: {
                    Desktop: '560px',
                    Tablet: '560px',
                    Mobile: '560px'
                },
            });

        } else {
            setAttributes({ vimeourl: '' });
        }
    };

    const video_select = (value) => {
        setAttributes({
            videoUrl: value.url,
            imageaspectratio: {
                Desktop: '16/9',
                Mobile: '16/9',
                Tablet: '16/9',
            },
            videoheight: {
                Desktop: '315px',
                Tablet: '315px',
                Mobile: '315px',
            },
            videowidth: {
                Desktop: '560px',
                Tablet: '560px',
                Mobile: '560px',
            },
        })
    };

    return (
        <div className="vb-video-uplo-container">
			{!attributes.videoUrl && attributes.blockValue === 'mp4' && (
				<div className="vb-video-uplo-card">
					<div className="vb-video-uplo-label">Upload Mp4 Video</div>
					<MediaUploadCheck>
						<MediaPlaceholder
							className="vb-video-uplo-placeholder"
							icon={<GoVideo />}
							labels={{ title: 'Upload a video' }}
							onSelect={(value) => video_select(value)}
							allowedTypes={['video']}
							accept="video/*"
							disableMediaButtons={!!attributes.videoUrl}
						/>
					</MediaUploadCheck>
				</div>
			)}

			{!attributes.youvideoUrl && attributes.blockValue === 'you-tube' && (
				<div className="vb-video-uplo-card">
					<div className="vb-video-uplo-label">YouTube Video URL</div>
					<URLInput
						className="vb-video-uplo-input"
						value={vayu_blcks_u_tube_url()}
						onChange={(url) => vayu_blocks_u_tube_video_change(url)}
						placeholder="https://youtube.com/..."
					/>
				</div>
			)}

			{!attributes.vimeourl && attributes.blockValue === 'vimeo' && (
				<div className="vb-video-uplo-card">
					<div className="vb-video-uplo-label">Vimeo Video URL</div>
					<URLInput
						className="vb-video-uplo-input"
						value={attributes.vimeourl || ''}
						onChange={(url) => vayu_blocks_vimeo_change(url)}
						placeholder="https://vimeo.com/..."
					/>
				</div>
			)}
		</div>
	);
};

export default VideoUploader;
